<template>
  <div id="footer">
    <span class="clr"></span>
    <div class="help-center-footer" v-if="$route.path !== '/login'">
      <div class="w" v-if="categories">
        <dl v-if="index < 5" v-for="(cate, index) in categories" :key="index" :class="`fore${++index}`">
          <dt>{{ cate.name }}</dt>
          <dd v-for="article in cate.articles" :key="article.article_id">
            <router-link :to="`/help/${article.article_id}`" target="_self">{{ article.article_name }}</router-link>
          </dd>
        </dl>
        <span class="clr"></span>
      </div>
    </div>
    <!-- TODO: fix -->
    <!-- <div class="link-footer" >
      <div class="w">
        <a href="/">首页</a>
        |
        <router-link to="/member">会员中心</router-link>
        | <a :href="user.have_shop ? MixinDomain.seller : '/shop/apply/'" target="_self">商家入驻</a>
        | <a href="/help/100" target="_self">关于网站</a>
        | <a href="/help/98" target="_self">关于我们</a>
        | <a href="/help/99" target="_self">联系我们</a>
        | <a href="https://www.willmid.cn" title="JAVA B2B2C网店系统">网店系统</a>
      </div>
    </div> -->
    <div class="link-footer">
      <div class="w">
        <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备 2022008343号-3</a> |
        <a href="https://dxzhgl.miit.gov.cn/#/home" target="_blank">增值电信业务经营许可证：沪B2-20220634</a> |
        <a href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91310000MA7E29J76Y-SAIC_SHOW_10000091310000MA7E29J76Y1682248091428&signData=MEQCIEnyrO83BBr8y+Ep80sWv0+8+JqGX1Bb0aZA5LsvA2i/AiBg2JkCCHknvqsXqZv/pf+toRslXJW7eoUTDUBe9c7bQQ==" target="_blank">营业执照</a> |
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502007719" target="_blank"><img src="https://www.purang.com/static/img/record-police.093bd14.png">沪公网安备 31011502007719号</a></p> 
        <p>Copyright 2018-2021 GESANGMEIDUO.COM 版权所有</p>
      </div>
    </div>

  </div>
</template>

<script>
import * as API_Article from '@/api/article'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EnFooter',
  data() {
    return {
      categories: []
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  async mounted() {
    const { children } = await API_Article.getArticleCategory('HELP')
    this.categories = children ? children.reverse() : []
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
@import '../assets/styles/color';
/* Footer */
#footer {
  background-color: #fff;
  a {
    color: #666;
  }
  a:hover {
    color: $color-main;
  }
  .help-center-footer {
    border-bottom: solid 1px #eaeaea;
    padding: 20px 0;
    dl {
      box-sizing: border-box;
      width: 20%;
      float: left;
      padding-left: 75px;
      line-height: 22px;
    }
    dt {
      padding-bottom: 6px;
      font-weight: 700;
      font-size: 14px;
      color: #777;
      height: 22px;
    }
    dd {
      font-size: 12px;
      color: #666;
      height: 22px;
      overflow: hidden;
    }
  }
  .link-footer {
    text-align: center;
    height: 40px;
    line-height: 30px;
    p{
      margin: 10px 0;
    }
    a {
      margin: 10px;
    }
    // line-height: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue